import { render, staticRenderFns } from "./KnowledgeItemsDetailView.vue?vue&type=template&id=06a4c5af&scoped=true"
import script from "./KnowledgeItemsDetailView.vue?vue&type=script&lang=js"
export * from "./KnowledgeItemsDetailView.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeItemsDetailView.vue?vue&type=style&index=0&id=06a4c5af&prod&lang=scss"
import style1 from "./KnowledgeItemsDetailView.vue?vue&type=style&index=1&id=06a4c5af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a4c5af",
  null
  
)

export default component.exports